
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getByToken = async ( tokenAnamnesis ) => {

  const query = `
    query GetAllAnamnesis($tokenAnamnesis: String) {
      getAllAnamnesis(tokenAnamnesis: $tokenAnamnesis) {
        total
        status
        message
        anamnesis {
          id
          token
          motivoConsulta
          problemaActual
          semiologia
          ptratamiento
          obsadicionalAp
          obsadicionalAf
          obsadicionalRo
          obsadicionalEf
          consultamedica {
            id
            token
            tipoConsulta {
              id
              descripcion
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAnamnesis
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.getAllAnamnesis;

    if( response2.status !== 200 ) {
      console.error('ocurrio un error', response2);
      return null
    }

    if( response2.anamnesis.length === 0 ) {
      console.error('no se encontro anamnesis');
      return null;
    }

    const data = response2.anamnesis[0];

    return data;

  } catch (error) {
    console.error(error);
    return null;
  }
}


const getByAtencion = async ( tokenAtencion ) => {

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          semiologia
          id
          token
          cita {
          doctor{
          especialidad{
          descripcion
          codEsp
          }}}
          tipoConsulta{ id, descripcion }
          anamnesisSet{
            id
            motivoConsulta
            problemaActual
            ptratamiento
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ){
      console.error('ocurrio un error', response2);
      return null
    }

    if( response2.atcm.length === 0 ) {
      console.error('no se encontro anamnesis');
      return null;
    }

    if( response2.atcm[0].anamnesisSet.length === 0 ) return null;

    const data = response2.atcm[0].anamnesisSet[0];
    const atencion = response2.atcm[0] 
    const tipoConsulta  = response2.atcm[0].tipoConsulta || "";

    const dataMap = {
      id: data.id,
      tipoConsulta,
      motivoConsulta: data.motivoConsulta,
      problemaActual: data.problemaActual,
      planTratamiento: data.ptratamiento,
      semiologia: atencion.semiologia ? JSON.parse(atencion.semiologia) : null,
      especialidad:atencion.cita?.doctor?.especialidad
    };

    return dataMap;

  } catch (error) {
    console.error(error);
    return null;
  }
}

const lastOdontogramaInicial = async (id_paciente) => {

const query = `
query ObtainLastOdontogramaAnual($paciente: ID!) {
    obtainLastOdontogramaAnual(paciente: $paciente) {
        id
        fechaCreacion
        ultimoCambio
        token
        fechaPrimeraToma
        data
        estado
    }
}
`;


  const variables = {
    paciente : id_paciente
 };


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    if( response.status !== 200 ) return null;
    
    const response2 = response.data.data.obtainLastOdontogramaAnual;
  

    const data = response2;
    return data;

  }catch(error){
    console.error('Error al registrar ODONTOGRAMA ANUAL', error);
    return null;
  }
  

}

const getOdontogramaById = async (id) => {

const query = `
query obtainOdontogramaById($idOdontograma: ID!) {
    obtainOdontogramaById(idOdontograma: $idOdontograma) {
        id
        fechaCreacion
        ultimoCambio
        token
        fechaPrimeraToma
        data
        estado
    }
}
`;


  const variables = {
    idOdontograma : id
 };


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    console.log(response)
    if( response.status !== 200 ) return null;
    
    const response2 = response.data.data.obtainOdontogramaById;    

    const data = response2;
    return data;

  }catch(error){
    console.error('Error al registrar ODONTOGRAMA ANUAL', error);
    return null;
  }
  

}

const saveOdontogramaInicial = async (idCita, dataSemiologia, idOdontograma = null ) => {


  if( !idCita ) {
    console.error('id atencion es requerido');
    return null
  }

  if( !dataSemiologia ) {
    console.error('data anamnesis es requerido');
    return null
  }
const query = `
  mutation SaveOdontograma($odontoData: odontogramaInput!) {
    saveOdontograma(odontoData: $odontoData) {
      message
      status
      odontogramaCreado {
        id
        fechaCreacion
        ultimoCambio
        token
        fechaPrimeraToma
        data
        estado
      }
    }
  }
`;


  const variables = {
  odontoData: {
    idOdontograma: idOdontograma,  
    cita: idCita,            
    data: JSON.stringify(dataSemiologia)
  }
 };


  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    console.log('response data save odontograma', response);

    if( response.status !== 200 ) return null;
    
    const response2 = response.data.data.saveOdontograma;
    if( response2.status !== 'success' ) return null;

    const data = response2.odontogramaCreado;
    return data;

  }catch(error){
    console.error('Error al registrar ODONTOGRAMA ANUAL', error);
    return null;
  }
  

}



const register = async (idAtencion, idCita, dataAnamnesis ) => {


  if( !idAtencion ) {
    console.error('id atencion es requerido');
    return null
  }

  if( !dataAnamnesis ) {
    console.error('data anamnesis es requerido');
    return null
  }

  const query = `
    mutation crearAnamnesis(
      $dataAnamnesis  : String!, 
      $atencionMedica : ID!, 
      $cita           : String!
    ){ 
      crearAnamnesis(
        dataAnamnesis  : $dataAnamnesis, 
        atencionMedica : $atencionMedica, 
        cita           : $cita
      ){
        anamnesis {
          id, token
        }
        status,
        message
      }
    }
  `;

  const anamnesisToBack = [{
    motivoConsulta        : dataAnamnesis.motivoConsulta  || null,
    antPerDetails         : dataAnamnesis.antecedentesPersonales || null,
    antecedentesFamDetails: dataAnamnesis.antecedentesFamiliares || null,
    problema              : dataAnamnesis.problemaActual  || null,
    antecedentesRevDetails: dataAnamnesis.revisionOrganos || null,
    exaFisDetails         : dataAnamnesis.examenFisico    || null,
    diagnosticos          : dataAnamnesis.diagnostico     || null,
    ptratamiento          : dataAnamnesis.planTratamiento || null,
    semiologia            : JSON.stringify(dataAnamnesis.semiologia) ||  null
  }];

  const variables = {
    dataAnamnesis  : JSON.stringify(anamnesisToBack),
    atencionMedica : idAtencion,
    cita           : idCita,
  };


  console.log('anamnesisToBack', anamnesisToBack);

  try{
    const response = await axios.post(rutas.axios + "api", { query, variables });
    console.log('response anamnesis', response);

    if( response.status !== 200 ) return null;
    
    const response2 = response.data.data.crearAnamnesis;
    if( response2.status !== 'success' ) return null;

    const data = response2.anamnesis;
    return data;

  }catch(error){
    console.error('Error al registrar Anamnesis', error);
    return null;
  }
  

}



const update = async (inputAnamnesis) => {

  
  const query = `
    mutation MyMutation($input : UpdateAnamnesisInput!) {
    updateAnamnesis(
      input: $input
    ) {
        message
        status
        anamnesis {
        id
        consultamedica {
          tipoConsulta {
            descripcion
          }
        }
          motivoConsulta
          problemaActual
          ptratamiento
        }
      }
    }
  `;
   
  const input = inputAnamnesis;

  try {
    const response = await axios.post(rutas.axios + "api", {
      query: query,
      variables: input,
    });
    if (response.data.data.updateAnamnesis.status === "success") {
      console.log("se edito la anamnesis", response.data.data.updateAnamnesis)

      // this.$swal({
      //   title: "Exito",
      //   text: "Se actualizaron los campos de anamnesis",
      //   icon: "success",
      //   confirmButtonText: "Entendido",
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     this.$router.go(0);
      //   }
      // });
    }
  } catch (error) {
    console.error("Error :", error.response.data);
  }
  

}


const getAntPersonalesByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token
          
          anamnesisSet{
            id
            token
            obsadicionalAp
          }

          anteperanamSet{
            id
            token
            descripcionGeneral
            anio
            antescedentesPersonales{
              id, descripcion
            }
          }

        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];

    const dataMap = {
      antecedentes: data.anteperanamSet,
      observaciones: data.anamnesisSet[0]?.obsadicionalAp || ''
    }

    return dataMap;

  }catch(error){
    console.log('error al traer los antecedentes personales', error)
    return null;
  }
}


const getAntFamiliaresByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token

          anamnesisSet{
            id
            token
            obsadicionalAf
          }

          antefamanamSet{
            id
            token
            familiar
            descripcionGeneral
            antescedentesFamiliares{
              id, descripcion 
            }
          }

        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    console.log(response)

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];

    const dataMap = {
      antecedentes: data.antefamanamSet,
      observaciones: data.anamnesisSet[0]?.obsadicionalAf || ''
    }

    console.log('dataMap', dataMap)

    return dataMap;

  }catch(error){
    console.log('error al traer los antecedentes personales', error)
    return null;
  }

}


const getRevOrganosByAtencion = async ( tokenAtencion ) => {
  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token

          anamnesisSet{
            id
            token
            obsadicionalRo
          }

          revorganamSet{
            id
            token
            revisionorganos{
              descripcion
              id
            }   
            descripcionGeneral
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];

    const dataMap = {
      revisiones   : data.revorganamSet,
      observaciones: data.anamnesisSet[0]?.obsadicionalRo || ''
    }

    return dataMap;


  }catch(error){
    console.error('Error al traer las revisiones de Organos', error);
  }
}


const getExamFisicosByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion:String) {
      allAtenmedica( tokenAtencion:$tokenAtencion ) {
        total
        status
        message
        atcm {
          id
          token

          anamnesisSet{
            id
            token
            obsadicionalEf
          }

          exafisanamSet{
            id
            token
            examenfisico{
              id
              descripcion
            }
            descripcionGeneral
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    const response2 = response.data.data.allAtenmedica;

    if( response2.status !== 'success' ) return null;
    if( response2.atcm.length === 0 ) return null;

    const data = response2.atcm[0];

    const dataMap = {
      examenes   : data.exafisanamSet,
      observaciones: data.anamnesisSet[0]?.obsadicionalEf || ''
    }

    return dataMap;

  }catch(error){
    console.error('Error al traer las revisiones de Organos', error);
    return null
  }
}



export const anamnesisService = {
  getByToken,
  getByAtencion,
  register,
  update,
  getAntPersonalesByAtencion,
  getAntFamiliaresByAtencion,
  getRevOrganosByAtencion,
  getExamFisicosByAtencion,
  saveOdontogramaInicial,
  lastOdontogramaInicial,
  getOdontogramaById
}